module.exports = __webpack_public_path__ + "static/media/posts-7.ec2ceaf7.jpg";